import { PostAuthorLabel, PostCategoryTag, PostPlaceholderImage } from '@components/Post';
import { PostBase, sortPostCategoriesByLabel } from '@core/content';
import { mc, StyleProps } from '@styles';
import { format } from 'date-fns';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import React, { FC } from 'react';

interface Props extends StyleProps {
  layout?: 'vertical' | 'horizontal';
  theme?: 'orange' | 'green';
  item: PostBase;
}

export const PostBaseCard: FC<Props> = ({ layout = 'vertical', theme, className, item }) => {
  const { title, url, authorName, createdAt, categories } = item;
  const image = item.headerImage?.childImageSharp?.cardMainLayoutFixedImage || getImage(item.headerImage as ImageDataLike);

  const renderMeta = () => (
    <div className="flex flex-row items-center">
      <span className="block text-sm font-medium text-ocean-blue">{format(new Date(createdAt), 'MMMM dd, yyyy')}</span>
    </div>
  );

  if (layout === 'horizontal')
    return (
      <a href={url} className={mc(`hover:opacity-75 flex flex-col lg:flex-row items-start lg:-mx-3`, className)}>
        <div className="w-full lg:w-5/12 lg:px-3">
          {image ? (
            <GatsbyImage className="rounded-lg" alt={title} image={image} />
          ) : (
            <PostPlaceholderImage className="rounded-lg" alt={title} />
          )}
        </div>

        <div className="w-full lg:w-7/12 lg:px-3">
          <div className="py-3 -mx-1 -my-1">
            {sortPostCategoriesByLabel(categories).map(c => (
              <PostCategoryTag theme={theme} containerClassName="px-1 py-1" key={c} title={c} />
            ))}
          </div>

          <h5 className="truncate mt-0 mb-0 font-sans font-bold text-lg text-ellipsis">{title}</h5>

          {!!authorName && (
            <div className="pt-4">
              <PostAuthorLabel
                author={{
                  name: authorName,
                }}
                link={false}
              />
            </div>
          )}
          {renderMeta()}
        </div>
      </a>
    );

  return (
    <a href={url} className={mc(`block hover:opacity-75`, className)}>
      {image ? (
        <GatsbyImage className="rounded-lg" alt={title} image={image} />
      ) : (
        <PostPlaceholderImage className="rounded-lg" alt={title} />
      )}

      <div className="lg:px-6">
        <div className="py-6 pb-4 -mx-1 -my-1">
          {sortPostCategoriesByLabel(categories).map(c => (
            <PostCategoryTag containerClassName="px-1 py-1" theme={theme} key={c} title={c} />
          ))}
        </div>

        <h5 className="mt-0 mb-0 font-sans font-bold text-xl">{title}</h5>

        {!!authorName && (
          <div className="pt-4">
            <PostAuthorLabel
              author={{
                name: authorName,
              }}
              link={false}
            />
          </div>
        )}
        {renderMeta()}
      </div>
    </a>
  );
};

export default PostBaseCard;
